import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-get-start',

  templateUrl: './get-start.component.html',
  styleUrls: ['./get-start.component.css'],
})
export class GetStartComponent {
  services = [
    {
      color: 'blue',
      img: ' ../../../assets/icon/lamp.png',
      title: 'CV Maker',
      description:
        'With our online resume maker - you can select a template, import an existing resume or craft a new one from scratch within minutes.',
    },
    {
      color: 'pink',
      img: '../../../assets/icon/share.png',

      title: 'Share and Download',
      description:
        'Share your CV with a convenient link via email or social media, and export as a PDF to apply directly to an employer.',
    },
    {
      color: 'blue',
      img: '../../../assets/icon/paper.png',

      title: 'Manage Multiple CVs',
      description:
        "In today's competitive market, customization is key. Easily manage multiple VisualCV versions, personalized for each application.",
    },
    {
      color: 'pink',
      img: '/../../assets/icon/contact.svg',

      title: 'Track Your Results',
      description:
        'CV analytics will let you know when an employer views or downloads your CV.',
    },
    {
      color: 'blue',
      img: '../../../assets/icon/privicy.png',

      title: 'Data and Privacy Control',
      description:
        'We don’t share your information with anyone (unless you explicitly ask us to), and have 3 CV privacy options to ensure your data stays safe.',
    },
  ];
  cvTempletes = [
    '../../../../assets/img/cv-templetes/1.png',
    '../../../../assets/img/cv-templetes/2.png',
    '../../../../assets/img/cv-templetes/3.png',
    '../../../../assets/img/cv-templetes/4.png',
    '../../../../assets/img/cv-templetes/5.png',
    '../../../../assets/img/cv-templetes/6.png',
    '../../../../assets/img/cv-templetes/7.png',
    '../../../../assets/img/cv-templetes/8.png',
    '../../../../assets/img/cv-templetes/9.png',
    '../../../../assets/img/cv-templetes/10.png',
    '../../../../assets/img/cv-templetes/11.png',
    '../../../../assets/img/cv-templetes/12.png',
  ];
  responsiveOptions = [
    {
      breakpoint: '1199px',
      numVisible: 4,
      numScroll: 1,
    },
    {
      breakpoint: '991px',
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: '767px',
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1,
    },
  ];
}
